import React from 'react';
import {
  IconTruck,
  IconLocationDot,
  IconXmark,
  IconCircleQuestion,
  IconBell,
  IconFileLines,
  IconGraduationCap
} from '../../components/ui-kit/icons';
import { FormattedPeriod } from '../../utils/time';
import moment from 'moment';
import 'moment-duration-format';
import { Badge } from '../../../javascript/components/ui-kit';

export const ReportedStatus = ({ status, type }) => {
  if (!status) return null;

  const i18nScope =
    type === 'activity_report'
      ? 'classy_enum.incidents/activity_attendance_reported_status'
      : 'classy_enum.incidents/incident_response_reported_status';
  const title = I18n.t(i18nScope)[status];
  const iconNames = {
    attended: IconTruck,
    dispatched: IconTruck,
    no_show: IconXmark,
    unknown: IconCircleQuestion,
    shown_up: IconLocationDot
  };

  const Icon = iconNames[status];

  return <Icon title={title} />;
};

export const PerformedRank = ({ reported_status, original_rank, performed_rank }) => {
  if (reported_status !== 'dispatched') return null;

  if (!original_rank || original_rank.id === performed_rank.id) return performed_rank?.name;

  return I18n.t('incident_responses.performed_rank_comparison', {
    performed: performed_rank.name,
    original: original_rank.name
  });
};

export const AttendanceTimes = ({ start, end }) => {
  if (!start || !end) return null;
  const long_activity = moment(end).diff(moment(start), 'hours') > 6 ? true : false;
  const variant = long_activity ? 'warning' : 'info';
  const difference = moment.duration(moment(end).diff(start));

  return (
    <div>
      <FormattedPeriod start={start} end={end} />
      <Badge variant={variant} style={{ marginLeft: '10px' }}>
        {difference.format('hh:mm', { trim: false })}
      </Badge>
    </div>
  );
};

export const reportIcon = ({ type }) => {
  const Icon = {
    incident_alert: IconBell,
    incident_report: IconFileLines,
    activity_report: IconGraduationCap
  }[type];

  const title = {
    incident_alert: I18n.t('activerecord.models.incidents/incident_alert.one'),
    incident_report: I18n.t('activerecord.models.incidents/incident_report.one'),
    activity_report: I18n.t('activerecord.models.incidents/general_activity_report.one')
  }[type];

  return <Icon title={title} />;
};
